export default __webpack_public_path__ + "resources/icons/n441-59b2.webp";